import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, ChevronDown } from 'lucide-react';

const ContactUs = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [coursesOpen, setCoursesOpen] = useState(false);

  return (
    <div className="bg-[#f7f6f3] text-gray-800 font-sans">
      {/* Header Bar */}
      <div className="bg-[#333] text-white text-sm py-2 px-4 flex flex-col md:flex-row md:justify-between items-center gap-2 text-center">
        <div className="flex flex-col md:flex-row items-center gap-2">
          <a href="mailto:admin@kentacademy.co.uk" className="hover:underline">
            📧 admin@kentacademy.co.uk
          </a>
        </div>
        <a
          href="https://www.facebook.com/share/16qS8YJbJc/?mibextid=wwXIfr"
          target="_blank"
          rel="noopener noreferrer"
          className="text-white hover:underline flex items-center gap-1"
        >
          <img src="/assets/facebook-icon.png" alt="Facebook" className="w-5 h-5" />
          facebook.com/KentAcademy
        </a>
      </div>

     {/* Navigation */}
<nav className="bg-white shadow-sm w-full z-50 border-b border-gray-200">
  <div className="max-w-7xl mx-auto px-4 pt-6 pb-4 flex items-center justify-center">
  <Link to="/" className="cursor-pointer">
  <img
    src="/assets/KaLogo.png"
    alt="Kent Academy"
    className="h-40 w-auto object-contain"
  />
</Link>

  </div>
  
  {/* Desktop Nav */}
  <div className="bg-[#f7f6f3] border-t border-gray-200 hidden md:flex">
    <div className="max-w-4xl mx-auto px-4 flex justify-between items-center text-sm font-medium py-3 relative w-full">
      <Link to="/" className="text-gray-800 hover:text-black transition-colors duration-200">HOME</Link>
      <Link to="/about" className="text-gray-800 hover:text-black transition-colors duration-200">ABOUT US</Link>
      
      <div
        className="relative cursor-pointer group"
        onMouseEnter={() => setCoursesOpen(true)}
        onMouseLeave={() => setCoursesOpen(false)}
      >
        <div className="flex items-center gap-1 text-gray-800 hover:text-black transition-colors duration-200 cursor-pointer">
          <span>ALL COURSES</span>
          <ChevronDown 
            size={16} 
            className={`transition-transform duration-200 ${coursesOpen ? 'rotate-180' : ''}`}
          />
        </div>
        
        {/* Dropdown */}
        <div className={`absolute top-full left-1/2 transform -translate-x-1/2 mt-1 transition-all duration-200 z-50 ${
          coursesOpen 
            ? 'opacity-100 visible translate-y-0' 
            : 'opacity-0 invisible -translate-y-2'
        }`}>
          <div className="absolute -top-1 left-1/2 transform -translate-x-1/2 w-3 h-3 bg-white border-l border-t border-gray-200 rotate-45"></div>
          
          <div className="bg-white border border-gray-200 rounded-md shadow-lg w-64 overflow-hidden">
            <div className="py-1">
              {/* Level 3 first */}
              <Link 
                to="/courses/vietnamese-nails" 
                className="block px-4 py-2 hover:bg-gray-50 transition-colors duration-150"
              >
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-pink-600 rounded-full"></div>
                  <div>
                    <h4 className="font-medium text-gray-900 text-sm">Level 3 in Nail Technology</h4>
                    <p className="text-xs text-gray-600">Bilingual training for UK professionals</p>
                  </div>
                </div>
              </Link>

              <Link 
                to="/courses/laser-and-light" 
                className="block px-4 py-2 hover:bg-gray-50 transition-colors duration-150"
              >
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-blue-600 rounded-full"></div>
                  <div>
                    <h4 className="font-medium text-gray-900 text-sm">Level 4 in Laser and Light</h4>
                    <p className="text-xs text-gray-600">Professional laser training</p>
                  </div>
                </div>
              </Link>

              <Link 
                to="/courses/tattoo-removal" 
                className="block px-4 py-2 hover:bg-gray-50 transition-colors duration-150"
              >
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-purple-600 rounded-full"></div>
                  <div>
                    <h4 className="font-medium text-gray-900 text-sm">Level 5 in Tattoo Removal</h4>
                    <p className="text-xs text-gray-600">CPD Available</p>
                  </div>
                </div>
              </Link>
            </div>

            {/* Optional: keep Services overview */}
            <div className="border-t border-gray-100 px-2 py-2">
              <Link 
                to="/services" 
                className="block w-full text-center py-1 px-3 bg-gray-800 text-white rounded text-xs font-medium hover:bg-black transition-colors duration-200"
              >
                View All Courses
              </Link>
            </div>
          </div>
        </div>
      </div>
      
      <Link to="/contact" className="text-gray-800 hover:text-black transition-colors duration-200">CONTACT</Link>
    </div>
  </div>

  {/* Mobile Dropdown Toggle */}
  <div className="md:hidden flex justify-center pb-3">
    <button
      onClick={() => setMobileOpen(!mobileOpen)}
      className="text-sm border px-4 py-2 rounded text-gray-800 border-gray-600 hover:bg-gray-100 transition-colors duration-200"
    >
      {mobileOpen ? 'Close Menu' : 'Menu'}
    </button>
  </div>

  {/* Mobile Dropdown Nav */}
  {mobileOpen && (
    <div className="md:hidden bg-[#f7f6f3] border-t border-gray-200 px-6 py-4 flex flex-col items-center gap-3 text-sm font-medium">
      <Link to="/" onClick={() => setMobileOpen(false)} className="text-gray-800 hover:text-black transition-colors duration-200">HOME</Link>
      <Link to="/about" onClick={() => setMobileOpen(false)} className="text-gray-800 hover:text-black transition-colors duration-200">ABOUT US</Link>
      <div className="text-gray-800 font-medium">COURSES:</div>
      {/* Level 3 first */}
      <Link to="/courses/vietnamese-nails" onClick={() => setMobileOpen(false)} className="text-gray-700 hover:text-black transition-colors duration-200 pl-4">Level 3 in Nail Technology</Link>
      <Link to="/courses/laser-and-light" onClick={() => setMobileOpen(false)} className="text-gray-700 hover:text-black transition-colors duration-200 pl-4">Level 4 in Laser and Light</Link>
      <Link to="/courses/tattoo-removal" onClick={() => setMobileOpen(false)} className="text-gray-700 hover:text-black transition-colors duration-200 pl-4">Level 5 in Tattoo Removal</Link>
      <Link to="/contact" onClick={() => setMobileOpen(false)} className="text-gray-800 hover:text-black transition-colors duration-200">CONTACT</Link>
      <a
        href="mailto:admin@kentacademy.co.uk"
        className="inline-block border border-gray-800 text-gray-800 px-3 py-1 rounded hover:bg-gray-800 hover:text-white transition-colors duration-200"
      >
        Contact Us
      </a>
    </div>
  )}
</nav>


      {/* Header */}
      <section className="relative pt-44 pb-12 px-6 w-full">
        <div className="relative z-10 max-w-3xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl font-light mb-4">
            Contact <span className="font-semibold">Kent Academy</span>
          </h1>
          <p className="text-gray-700 text-md">
            Reach out for course enquiries, support or partnership opportunities — we're here to help.
          </p>
          <div className="mt-6 inline-flex items-center gap-3 justify-center">
            <a
              href="mailto:admin@kentacademy.co.uk"
              className="inline-block bg-gray-800 text-white px-6 py-3 rounded hover:bg-black transition-colors duration-200"
            >
              Contact Us
            </a>
          </div>
        </div>
      </section>

      {/* Contact Info + Map */}
      <section className="pb-20 px-6 max-w-6xl mx-auto grid md:grid-cols-2 gap-10 items-start">
        <div>
          <h3 className="text-2xl font-semibold mb-4">Find Us</h3>
          <ul className="space-y-3 text-sm text-gray-700">
            <li><strong>Phone:</strong> 07548321022</li>
            <li><strong>Phone:</strong>Vietnamese Courses: 07548321022</li>
            <li><strong>Email:</strong> admin@kentacademy.co.uk</li>
            <li><strong>Address:</strong> Unit 10, Creative Quarter, Javelin Way, Ashford TN24 8FN</li>
            <li>
              <a
                href="https://www.facebook.com/share/16qS8YJbJc/?mibextid=wwXIfr"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-800 hover:underline visited:text-gray-800 flex items-center gap-2"
              >
                <img src="/assets/facebook-icon.png" alt="Facebook" className="w-5 h-5" />
                facebook.com/KentAcademy
              </a>
            </li>
          </ul>
        </div>
        <div className="w-full h-80 rounded-xl overflow-hidden shadow">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d40043.30924377384!2d0.8546727791015742!3d51.150757200000015!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47deda3c16675eb9%3A0x303bc8b61811e439!2sKent%20Sports%20Academy!5e0!3m2!1sen!2suk!4v1753635190360!5m2!1sen!2suk"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Kent Academy Map"
          ></iframe>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#333] text-white py-12">
        <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-3 gap-8 text-sm">
          <div>
            <img src="/assets/KaLogo.png" alt="Kent Academy" className="w-14 mb-3" />
            <p className="text-gray-300">
              Kent Academy delivers advanced beauty training with professional-grade equipment and expert guidance.
            </p>
          </div>
          <div>
            <h4 className="font-semibold mb-2">Courses</h4>
            <ul className="space-y-1 text-gray-400">
              <li>Level 4 in Laser and Light</li>
              <li>Level 5 in Tattoo Removal</li>
              <li>Level 3 in Nail Technology</li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold mb-2">Contact</h4>
            <ul className="space-y-1 text-gray-400">
              <li>
                <a href="mailto:admin@kentacademy.co.uk" className="hover:text-gray-300 transition-colors duration-200">
                  admin@kentacademy.co.uk
                </a>
              </li>
              <li>General: 07548321022</li>
              <li>Vietnamese Courses: 07735906672</li>
              <li>Unit 10, Creative Quarter, Javelin Way, Ashford TN24 8FN</li>
              <li>
                <a
                  href="https://www.facebook.com/share/16qS8YJbJc/?mibextid=wwXIfr"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-white hover:underline"
                >
                  <img src="/assets/facebook-icon.png" alt="Facebook" className="w-6 h-6" />
                  facebook.com/KentAcademy
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-10 text-center text-xs text-gray-400">© 2025 Kent Academy. All rights reserved.</div>
      </footer>
    </div>
  );
};

export default ContactUs;
